import React from 'react';
import { isOpenableUrl } from './apiError';

/**
 * Shown when openServerUrl returned false. A valid https URL means the popup was blocked, so the
 * message carries the link itself (clickable, and copied to the clipboard when permitted);
 * otherwise the link was refused as invalid.
 * @param {{warning: Function, error: Function}} message antd message API
 */
export function reportOpenFailure(message, url) {
    if (!isOpenableUrl(url)) {
        message.error('The file link was not valid. Please try again.');
        return;
    }
    try { navigator.clipboard?.writeText(url).catch(() => {}); } catch { /* clipboard unavailable */ }
    message.warning({
        duration: 15,
        content: React.createElement(
            'span',
            null,
            'Your browser blocked the new tab. Open or copy the link: ',
            React.createElement('a', { href: url, target: '_blank', rel: 'noopener noreferrer' }, 'Open file'),
        ),
    });
}
